import { render, staticRenderFns } from "./XifresAnuals.vue?vue&type=template&id=6759ee09&"
import script from "./XifresAnuals.vue?vue&type=script&lang=js&"
export * from "./XifresAnuals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports